import { Space } from 'antd'
import { Popover } from 'antd'
import Map, { Props as MapProps } from './Map'
import { blue } from '@ant-design/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe } from '@fortawesome/pro-solid-svg-icons'

export type Props = MapProps & { label?: string }

const PopupMap = (props: Props) => {
  return <Popover content={<Map {...props} />} trigger="hover" zIndex={2000} placement="right">
    <Space style={{ color: blue.primary, cursor: 'pointer' }}>
      {props.label}
      <FontAwesomeIcon icon={faGlobe} />
    </Space>
  </Popover>
}
export default PopupMap
